// Mock data para demonstração dos dashboards

export const mockTransactions = [
  {
    id: '1',
    date: '2026-01-08',
    description: 'Pagamento Conta de Luz',
    amount: -12500,
    status: 'completed',
    type: 'bill',
  },
  {
    id: '2',
    date: '2026-01-07',
    description: 'Transferência Recebida',
    amount: 50000,
    status: 'completed',
    type: 'transfer',
  },
  {
    id: '3',
    date: '2026-01-06',
    description: 'Compra Loja Online',
    amount: -8750,
    status: 'completed',
    type: 'purchase',
  },
  {
    id: '4',
    date: '2026-01-05',
    description: 'Pagamento Evento',
    amount: -2500,
    status: 'completed',
    type: 'event',
  },
  {
    id: '5',
    date: '2026-01-04',
    description: 'Doação ONG',
    amount: -1000,
    status: 'completed',
    type: 'donation',
  },
];

export const mockMonthlyExpenses = [
  { month: 'Jul', value: 45000 },
  { month: 'Ago', value: 52000 },
  { month: 'Set', value: 48000 },
  { month: 'Out', value: 61000 },
  { month: 'Nov', value: 55000 },
  { month: 'Dez', value: 72000 },
  { month: 'Jan', value: 65000 },
];

export const mockRevenueData = [
  { month: 'Jul', receitas: 120000, despesas: 45000 },
  { month: 'Ago', receitas: 135000, despesas: 52000 },
  { month: 'Set', receitas: 128000, despesas: 48000 },
  { month: 'Out', receitas: 150000, despesas: 61000 },
  { month: 'Nov', receitas: 145000, despesas: 55000 },
  { month: 'Dez', receitas: 180000, despesas: 72000 },
  { month: 'Jan', receitas: 165000, despesas: 65000 },
];

export const mockPaymentVolume = [
  { day: 'Seg', volume: 45 },
  { day: 'Ter', volume: 52 },
  { day: 'Qua', volume: 68 },
  { day: 'Qui', volume: 71 },
  { day: 'Sex', volume: 89 },
  { day: 'Sáb', volume: 34 },
  { day: 'Dom', volume: 28 },
];

export const mockUserGrowth = [
  { month: 'Jul', utilizadores: 1200 },
  { month: 'Ago', utilizadores: 1350 },
  { month: 'Set', utilizadores: 1480 },
  { month: 'Out', utilizadores: 1620 },
  { month: 'Nov', utilizadores: 1780 },
  { month: 'Dez', utilizadores: 1950 },
  { month: 'Jan', utilizadores: 2150 },
];

export const mockServicesUsage = [
  { name: 'Pagamento Contas', value: 450 },
  { name: 'Eventos', value: 280 },
  { name: 'E-commerce', value: 320 },
  { name: 'Doações', value: 150 },
  { name: 'Outros', value: 180 },
];

export const mockEntityStats = {
  totalEntities: 245,
  activeEntities: 228,
  totalRevenue: 1250000,
  totalTransactions: 15680,
  topEntities: [
    { name: 'Electra', transactions: 3420, revenue: 342000 },
    { name: 'Câmara Municipal', transactions: 2150, revenue: 215000 },
    { name: 'TACV', transactions: 1890, revenue: 189000 },
    { name: 'Universidade', transactions: 1650, revenue: 165000 },
    { name: 'Hospital', transactions: 1420, revenue: 142000 },
  ],
};

export const mockClientStats = {
  balance: 45750,
  totalSpent: 125680,
  transactions: 156,
  savedCards: 3,
  pendingPayments: 2,
  recentActivity: mockTransactions,
};

export const formatCurrency = (value: number): string => {
  const rounded = Math.round(value || 0);
  return rounded.toLocaleString('pt-PT') + '$';
};

export const formatNumber = (value: number): string => {
  return new Intl.NumberFormat('pt-CV').format(value);
};

export const formatDate = (date: string): string => {
  return new Date(date).toLocaleDateString('pt-CV', { timeZone: 'Atlantic/Cape_Verde',
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
};
